var map = {
	"./box.svg": 653,
	"./boxact.svg": 654,
	"./consigment.svg": 655,
	"./consigmentact.svg": 656,
	"./contact.svg": 657,
	"./contactact.svg": 658,
	"./delete.svg": 659,
	"./discount-active.svg": 660,
	"./discount.svg": 661,
	"./discountact.svg": 662,
	"./doswnload.svg": 663,
	"./download.svg": 664,
	"./email.svg": 469,
	"./equalizer.svg": 665,
	"./filter.svg": 666,
	"./gear.svg": 667,
	"./gearact.svg": 668,
	"./info.svg": 669,
	"./inventory.svg": 670,
	"./magnifiying-glass.svg": 671,
	"./notification.svg": 470,
	"./offer-active.svg": 672,
	"./offer.svg": 673,
	"./offeract.svg": 674,
	"./print.svg": 675,
	"./printer.svg": 676,
	"./settings-active.svg": 677,
	"./settings.svg": 678,
	"./settingsact.svg": 679,
	"./sort.svg": 680,
	"./storage.svg": 681,
	"./turn-off.svg": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 475;